import React, { useState } from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { Dialog } from "source/components/framework/Dialog/Dialog";
import { SelectUserGroupDialogList } from "../SelectUserGroupDialogList";
import { IUserGroupListItem } from "ui/Scripts/source/models/userGroup/userGroupListItem";
import { UserGroupListItems } from "ui/Scripts/source/models/userGroup/userGroupListItems";
import { UserGroupType } from "ui/Scripts/source/models/enums";

interface ISelectUserGroupDialogBaseProps {
    messageTargetMode?: boolean;
    listModeChangeDisabled?: boolean;
    multiSelect?: boolean;
    onCancel: () => void;
    onGetUserGroupListItems?: (companyId: string, pageSize: number, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean, groupType: number,
        ignoreUserGroupCodes: string[], requireUserGroupCodes: string[], ignoreQrCodeUserGroups: boolean, requireQrCodeUserGroups: boolean, messageTargetMode: boolean) => Promise<UserGroupListItems>;
}

interface ISelectUserGroupDialogProps extends ISelectUserGroupDialogBaseProps {
    companyId: string;
    title?: string;
    initiallySelectedUserGroupCodes?: string[];
    ignoreUserGroupCodes?: string[];
    requireUserGroupCodes?: string[];
    ignoreQrCodeUserGroups?: boolean;
    requireQrCodeUserGroups?: boolean;
    defaultUserGroupType?: UserGroupType;
    enableZeroSelection?: boolean;
    onOk: (userGroups: IUserGroupListItem[], userGroupType: UserGroupType) => void;
}

interface ISelectUserGroupDialogState {
    intialized: boolean;
    selectedId: string;
    checkedIds: string[];
    selectedItems: IUserGroupListItem[];
    userGroupType: UserGroupType;
}

export const SelectUserGroupDialog = (props: ISelectUserGroupDialogProps) => {
    const [state, setState] = useState<ISelectUserGroupDialogState>({
        intialized: false,
        selectedId: null,
        checkedIds: [],
        selectedItems: [],
        userGroupType: props.defaultUserGroupType ?? UserGroupType.Normal
    });

    const handleSetInitialized = (intialized: boolean) => {
        setState(old => ({
            ...old,
            intialized
        }));
    };

    const handleSetSelectedIds = (selectedId: string, checkedIds: string[], selectedItems: IUserGroupListItem[], userGroupType: UserGroupType) => {
        setState(old => ({
            ...old,
            selectedId,
            checkedIds,
            selectedItems,
            userGroupType
        }));
    };

    const handleOk = () => {
        if (state.selectedItems.length < 1 && !props.enableZeroSelection) return;
        props.onOk(state.selectedItems, state.userGroupType);
    };

    return (
        <Dialog
            id="selectUserGroupDialog"
            maxWidth="md"
            maxHeight="726px"
            hide={!state.intialized}
            title={props.title ?? Translations.SelectUserGroup}
            body={
                <SelectUserGroupDialogList
                    companyId={props.companyId}
                    defaultUserGroupType={props.defaultUserGroupType}
                    initiallySelectedUserGroupCodes={props.initiallySelectedUserGroupCodes}
                    ignoreUserGroupCodes={props.ignoreUserGroupCodes}
                    requireUserGroupCodes={props.requireUserGroupCodes}
                    ignoreQrCodeUserGroups={props.ignoreQrCodeUserGroups}
                    requireQrCodeUserGroups={props.requireQrCodeUserGroups}
                    listModeChangeDisabled={props.listModeChangeDisabled}
                    multiSelect={props.multiSelect}
                    intialized={state.intialized}
                    selectedId={state.selectedId}
                    checkedIds={state.checkedIds}
                    onSetIntialized={handleSetInitialized}
                    onSetSelected={handleSetSelectedIds}
                    onGetUserGroupListItems={props.onGetUserGroupListItems}
                />
            }
            buttons={[
                { title: Translations.Cancel, variant: "outlined", onClick: props.onCancel },
                { title: Translations.OK, variant: "confirmation", onClick: handleOk, disabled: state.selectedItems.length < 1 && !props.enableZeroSelection },
            ]}
            onClose={props.onCancel}
        />
    );
};